<template>
    <div class="feedList">
      <div class="header">
	      <p>反馈列表</p>
	    </div>
	    <div>
        <el-form :inline="true" :model='feedBack'>
          <el-form-item label='反馈用户'>
            <el-input v-model='feedBack.name'  style="width:300px"  placeholder='请输入反馈用户'></el-input>
          </el-form-item>
          <el-form-item label="反馈状态" label-width="100px">
            <el-select v-model='feedBack.status' placeholder="全部">
              <el-option label='未读' value='1'></el-option>
              <el-option label='已回复' value='3'></el-option>
              <el-option label='已忽略' value='2'></el-option>
              <el-option label='全部' value='0'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="margin-left:200px">
            <el-button type="primary" style="height: 35px;line-height: 10px;" @click="feedSearch">查询</el-button>
			      <el-button type="info" style="height: 35px;line-height: 10px;" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="content-wrap">
        <div class="content-list" v-for='(item,index) in feedData' :key='index'>
          <div :class="item.status==1?(contentRedStatus):(contentStatus)" >{{typeFormat(item.status)}}</div>
          <div class="content-author">
            <div class="content-title">反馈用户: <span class="content-font">{{item.realname}}</span></div>
            <div class="content-title">反馈时间: <span class="content-font">{{item.createTime}}</span></div>
          </div>
          <div class="content-feedContent">
            <div class="content-title content-feedTitle">反馈内容</div>
            <div class="content-feedImgBox" v-show='item.fileSign.length==0?false:true'>
              <div :class="imgClass(item.fileSign)"  v-for="(img,index) in item.fileSign"  :key='index' @click='imgBig(img)'>
                <img :src='img' class="table-img" />
              </div>
            </div>
            <div :class="item.fileSign.length==0?(feedText):(imgFeedText)">{{item.content}}</div>
          </div>
          <div class="content-operation" v-if='item.status==1'>
            <div class="content-btn content-ignore" @click='ignore(index)'>忽略</div>
            <div class="content-btn content-reply" @click='reply(index)'>回复</div>
          </div>
          <div class="content-operation" v-if='item.status!==1'>
            <div class="content-btn">忽略</div>
            <div class="content-btn">回复</div>
          </div>
        </div>
      </div>

      <div class="pageWrap">
        <el-pagination
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="count"
          @current-change="clickPage"
          >
        </el-pagination>
      </div>


      <el-dialog title='回复反馈'  :visible.sync="dialogVisible">
          <div class="dialogCell">
            <div class="dialogCell-left">反馈内容</div>
            <div class="dialogCell-imgBox">
              <div class="dialogCell-title">{{replyForm.replyTitle}}</div>
              <div :class='imgClass(replyForm.replyImgBox)' v-for='(item,index) in replyForm.replyImgBox' :key='index'>
                <img :src='item' class="table-img"/>
              </div>
            </div>
          </div>
          <div class="dialogCell">
            <div class="dialogCell-left">回复内容</div>
            <el-input type='textarea' class='dialogCell-textarea' :rows='5' placeholder='请输入回复内容' resize="none"  v-model='replyForm.replyDes'></el-input>
          </div>
          <div class="dialogCell-operation">
            <el-button @click='cancel'>取消</el-button>
            <el-button type="primary" @click='confirm'>确认</el-button>
          </div>
      </el-dialog>
      <imgpreview :img='imgSrc' :display='imgShow' @close='closeImg'></imgpreview>
    </div>
</template>

<script>
  import imgpreview from '@/components/imgPreview'
  import {feedbackList, feedbackIgnore, feedbackReply} from '@/api/parkManage'
  export default {
    name: '',
    props: [''],
    components:{
      imgpreview
    },
    data () {
      return {
        redNotice: 'redNotice',
        feedBack:{
          name: '',
          status: '',
        },
        feedData:[],
        contentRedStatus: 'contentRedStatus',
        contentStatus: 'contentStatus',
        dialogVisible: false,
        replyForm: {
          replyTitle: '',
          replyImgBox: [],
          replyDes: '',
        },
        feedId:'',
        currentPage: 1,
        pageSize: 4,
        count: 0,
        imgSrc: '',
        imgShow: false,
        feedText: 'content-feedText',
        imgFeedText: 'content-imgFeedText',
      };
    },
    mounted(){
      this.getList();
    },
    methods: {
      reset(){
        this.feedBack={
          name: '',
          status: '',
        }
      },
      feedSearch(){
        let {name,status} = this.feedBack;
        if(name !=''||status!='') this.getList();
      },
      typeFormat(type){
        let str = '';
        switch (type){
          case 1:
           str ='未读';
           break;
          case 2:
           str = '已忽略';
           break;
          case 3:
            str= '已回复';
            break;
        }
        return str;
      },
      imgClass(img){
        let num = img.length;
        switch (num){
          case 1:
            return 'content-feedImgOne'
            break;
          case 2:
          case 4:
            return 'content-feedImgTwo'
            break;
          case 3:
          case 5:
          case 6:
            return 'content-feedImgThree'
            break;
          default:
            return 'content-feedImgThree'
            break;
        }
      },
      ignore(id){
        let that = this
        let ingoreId = that.feedData[id].id;
        that.$confirm('是否确认忽略本条反馈内容','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          //@todo 向后台发送请求
          feedbackIgnore(ingoreId).then(res=>{
            that.feedData[id].status = 2;
          })

        }).catch(()=>{

        })
      },
      reply(id){
        let that = this;
        that.feedId = id;
        that.dialogVisible = true;
        that.replyForm.replyTitle = that.feedData[id].content;
        that.replyForm.replyImgBox = that.feedData[id].feedbackImage;
        that.replyForm.replyDes = '';
      },
      cancel(){
        this.dialogVisible = false;
      },
      confirm(){
        let that = this;
        that.dialogVisible = false;
        //@todo 向后台提交数据
        // console.log('id',this.feedId);
        let content = that.replyForm.replyDes;
        let index = that.feedId;
        let id = that.feedData[index].id;
        feedbackReply(id,content).then(res=>{
          that.feedData[index].status = 2;
        }).catch(err=>{

        })

      },
      imgBig(src){
        let that = this;
        that.imgSrc = src;
        that.imgShow = !that.imgShow;
      },
      closeImg(val){
        this.imgShow = !this.imgShow;
      },
      clickPage(val){
        this.currentPage = val;
        this.getList();
      },
      getList(){
        let that = this;
        let data= {
          username: that.feedBack.name,
          status: that.feedBack.status,
          currentPage: that.currentPage,
          pageSize: that.pageSize
        }
        feedbackList(data).then(res=>{
          that.feedData = res.data.feedbackList;
          that.count = res.data.count;
        }).catch(err=>{

        })
      }
    }
  }
</script>
<style scoped>
.feedList{
  min-width: 1000px;
}
.header{
  display: flex;
  justify-content: space-between;
}
.contentRedStatus{
  color: red;
  width: 60px;
  padding: 20px;
  text-align: center;
}
.content-wrap{
  min-width: 980px;
  overflow-x: scroll;
  margin: 20px 0;
  padding: 0 20px;
  height: 540px;
}
.content-list{
  width: 100%;
  height: 120px;
  display: flex;
  font-size: 16px;
  margin-bottom: 10px;
  justify-content: flex-start;
  position: relative;
  border-radius: 10px;
  background-color: #fff;
  align-items: center;
}
.contentStatus{
  width: 60px;
  padding: 20px;
  text-align: center;
}
.content-title{
  font-size: 14px;
  color: #b0b7bd;
}
.content-font{
  font-size: 14px;
  color: #52616f;
  margin-left: 5px;
}
.content-feedContent{
  display: flex;
  flex-direction: row;
  margin-left: 20px;
  align-items: center;
}
.content-feedTitle{
  width: 70px;
}
.content-feedImgBox{
  width: 300px;
  margin-right: 10px;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-content: flex-start;
}
.content-feedImgThree{
  box-sizing: border-box;
  flex: 0 0 28%;
  height: 40px;
  margin-top: 6px;
  margin-right: 10px;
  text-align: center
}
.content-feedImgTwo{
  box-sizing: border-box;
  flex: 0 0 45%;
  height: 40px;
  margin-top: 6px;
  margin-right: 10px;
  text-align: center
}
.content-feedImgOne{
  box-sizing: border-box;
  flex: 0 0 60%;
  height: 60px;
  margin-top: 6px;
  margin-right: 10px;
  text-align: center;
}
.content-imgFeedText{
  width: 200px;
  height: 60px;
  font-size: 14px;
  margin-right: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  /* white-space: nowrap; */
}
.content-feedText{
  width: 510px;
  font-size: 14px;
  margin-right: 10px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.content-operation{
  width: 12%;
  position: absolute;
  top: 50%;
  right: 40px;

  display: flex;
  margin-top: -25px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-left: 1px solid #ddd;

}
.content-btn{
  padding: 5px 0;
  font-size: 14px;
  color: rgb(170, 170, 170);
  cursor: default;
}
.content-reply{
  color: #409EFF;
  cursor: pointer;
}
.content-ignore{
  color:#52616f;
  cursor: pointer;
}
.dialogCell{
  margin: 0px 20px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
}
.dialogCell-left{
  width: 100px;
  color: #b0b7bd;
}
.dialogCell-title{
  width: 100%;
}
.dialogCell-imgBox{
  width: 310px;
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
}
.dialogCell-textarea{
  margin-left: 15px;
}
.dialogCell-operation{
  width: 100%;
  height: 50px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.pageWrap{
  margin-top: 20px;
  text-align: center;
}
.table-img{
  height: 100%;
  /* width: 100%; */
}
.content-author{
  min-width: 190px;
}
</style>



// WEBPACK FOOTER //
// src/pages/park/CircleFeedBack.vue